<template>
  <div class="split-icon float-left">
    <a
      class="home-split d-block"
      href="#"
      @click.prevent="setFavouriteModeLocal(!favouriteMode)"
    >
      <transition name="fade-full" mode="out-in">
        <img
          :src="favouriteActiveIcon"
          class="month-view-cal"
          v-if="favouriteMode"
          key="1"
        />
        <img :src="favouriteIcon" class="month-view-cal" v-else key="2" />
      </transition>
    </a>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      favouriteIcon: require("../../assets/img/m_favorites.png"),
      favouriteActiveIcon: require("../../assets/img/m_favorites-active.png"),
      mailBoxfavIconClickable: true,
      mailFolderfavIconClickable: true
    };
  },
  computed: {
    ...mapGetters("portalemail", {
      emaillist: "getEmails",
      favouriteMode: "getFavouriteMode"
    })
  },
  methods: {
    ...mapMutations("portalemail", {
      setFavouriteMode: "setFavouriteMode",
      resetEmails: "resetEmails",
      setBoxCount: "setBoxCount"
    }),
    ...mapActions("portalemail", {
      fetchMailCount: "fetchMailCount",
      loadEmails: "loadEmails"
    }),
    async setFavouriteModeLocal(value) {
      if (this.$route.params.type !== 'mailboxes') {
        if(this.isLoading() || !this.mailBoxfavIconClickable) {
          return false;
        }

        this.mailBoxfavIconClickable = false;

        // Setting the favorite mode
        this.setFavouriteMode(value);

        // Scrolling to top
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth"
        });

        // Resetting the mails
        this.resetEmails({boxType: 'all', folderId: 0});

        // Resetting the count
        this.setBoxCount({key: 'needLoad', value: true});

        // Making request to backend
        await this.loadEmails({
          type: this.$route.params.type,
          folderId: this.$route.params.folderId ? this.$route.params.folderId : 0
        });

        this.mailBoxfavIconClickable = true;
      } else {
        if(!this.mailFolderfavIconClickable) {
          return false;
        }

        this.mailFolderfavIconClickable = false;

        // Setting the favorite mode
        this.setFavouriteMode(value);

        // Scrolling to top
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth"
        });

        // Resetting the count
        this.setBoxCount({key: 'needLoad', value: true});

        // Resetting the mails
        this.resetEmails({boxType: 'all', folderId: 0});

        // Fetching mail count
        await this.fetchMailCount();

        this.mailFolderfavIconClickable = true;
      }
    },

    isLoading() {
      let type = this.$route.params.type;
      let isLoading = false;
      let folderId = this.$route.params.folderId;
      if('custom' === type) {
        if(this.emaillist[type][folderId]) {
          isLoading = this.emaillist[type][folderId].loading;
        } else {
          isLoading = false;
        }
      } else {
        isLoading = this.emaillist[type].loading;
      }

      return isLoading;
    }
  }/*,
  beforeDestroy() {
    this.setFavouriteMode(false);
  }*/
};
</script>

<style scoped>
img {
  max-width: 27px;
}

.fade-full-enter {
  opacity: 0;
}

/* stage 2. Entered */
.fade-full-enter-active {
  transition: opacity 0.1s ease-in-out;
}

/* stage 3. leave */
.fade-full-leave-active {
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
}
</style>
